import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../../utilities/TabGrid";
import {TopSelect} from "../../../../../../componentsTopsa/selects/TopSelects";


export default class KalendarzDoDatyTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderSelectKalendarz = this.renderSelectKalendarz.bind(this)
    }

    renderSelectKalendarz(cell, row) {

        let kalendarz = this.props.rodzajeKalendarzy.find(k => k.idRk === cell)

        return (
            <div>
                <TopSelect onChange={(e) => {
                    this.props.handleChangeKalendarz(row, e)
                }}
                           value={Boolean(kalendarz) ? kalendarz : null}
                           options={this.props.rodzajeKalendarzy}
                           valueKey={'idRk'}
                           labelKey={'nazRk'}
                />
            </div>
        )
    }

    render() {

        const options = {
            sizePerPage: 15,
            sizePerPageList: [10, 15, 30],
            defaultSortName: 'data',
            sortOrder:'asc',
            noDataText: 'Brak pasujących rekordów'
        };
        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                pagination
                                hover
                >
                    <TableHeaderColumn dataField='id' isKey hidden={true}>ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='data' dataSort
                                       thStyle={tabgrid.tg5} tdStyle={tabgrid.tg5}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Data</TableHeaderColumn>
                    <TableHeaderColumn dataField='opis'
                                       thStyle={tabgrid.tg10} tdStyle={tabgrid.tg10}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                    >Opis</TableHeaderColumn>
                    <TableHeaderColumn dataField='idRk'
                                       thStyle={tabgrid.tg10} tdStyle={tabgrid.tg10}
                                       filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                                       dataFormat={this.renderSelectKalendarz}
                    >Nazwa kalendarza</TableHeaderColumn>

                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/kalendarze/przypisanieKalendarzaDoDaty/components/KalendarzDoDatyTable.js